// extracted by mini-css-extract-plugin
export default {"label":"Slider_label__rh53r","grid":"Slider_grid__i8A33","input":"Slider_input__MmJPi","inputProps":"Slider_inputProps__RO-rH"};